export class StringUtils {
  static insertSpacesBetweenIds(ids: Array<string>): string {
    if (ids.length > 1) {
      return ids.toString().split(',').join(', ');
    } else {
      return ids.toString();
    }
  }
}
